import React from 'react';

import EditUserForm from '../Forms/EditUser';

const EditUser = () => {

  return (
    <>
      <h3 className="modal__header">Edit User</h3>

      <EditUserForm />
    </>
  );

}

export default EditUser;